<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button size="mini" class="filter-item" type="primary" @click="create">添加</el-button>
        <el-button size="mini" class="filter-item" type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" :width="80">
          <template slot-scope="{row}">
            <el-button
              v-if="row.StuCount==0"
              type="text"
              @click="edit(row)"
              size="medium"
              icon="el-icon-edit-outline"
              title="编辑"
            ></el-button>
            <template v-else>
              <el-button
                type="text"
                @click="details(row)"
                size="medium"
                icon="el-icon-document"
                title="查看"
              ></el-button>
              <el-button
                type="text"
                @click="detailsStu(row)"
                size="medium"
                icon="el-icon-notebook-1"
                title="开通记录"
              ></el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <details-dialog ref="detailsDialog" />
    <stu-dialog ref="stuDialog" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/consume/linksetting/list";
import editDialog from "@/components/consume/linksetting/editDialog";
import detailsDialog from "@/components/consume/linksetting/detailsDialog";
import stuDialog from "@/components/consume/linksetting/stuDialog";

export default {
  name: "linksetting",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    detailsDialog,
    stuDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    details(row) {
      this.$refs.detailsDialog.openDetails(row);
    },
    detailsStu(row) {
      this.$refs.stuDialog.openDetails(row);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.EduToHomeId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>